import { DownOutlined } from "@ant-design/icons";
import {
  Alert,
  App,
  Button,
  Col,
  Divider,
  Menu,
  message,
  Popover,
  Row,
  Tooltip,
  Typography,
} from "antd";
import MaterialTable from "material-table";
import QueryString from "query-string";
import { useEffect, useMemo, useState } from "react";
import { Form, Modal, Spinner } from "react-bootstrap";
import { MdOutlineClose } from "react-icons/md";
import { useSelector } from "react-redux";
import { useCountry, useCurrency } from "../../../provider/courtryProvider";
import {
  IoIosCheckmarkCircleOutline,
  IoIosCloseCircleOutline,
} from "react-icons/io";
import { BiMinus, BiPlus } from "react-icons/bi";
import { AiFillEdit } from "react-icons/ai";
import { tableIcons } from "../../../tableIcons";
import { TablePagination } from "@material-ui/core";
import config from "../../../config";
import { useLocation } from "react-router-dom";

const ReturnBillModal = ({ data, refetch = () => {} }) => {
  const [open, setOpen] = useState(false);
  const [returnProducts, setReturnProducts] = useState({});
  const { productList } = useSelector((state) => state.products);
  const [cancelType, setCancelType] = useState();
  const currencyFormatter = useCurrency();
  const location = useLocation();
  const [billFullyReturned, setBillFullyReturned] = useState(false);
  const { message } = App.useApp();
  const [cancelLoading, setCancelLoading] = useState(false);
  const [reasonForCancellation, setReasonForCancellation] = useState("");
  const country = useCountry();
  const invoiceSettings = useSelector(
    (state) => state.newInvoicesettings.newInvoicesettings
  );

  console.log("returnProducts", returnProducts);

  const onClose = () => {
    setOpen(false);
  };

  const returnedProductAmount = useMemo(() => {
    return returnProducts.items?.reduce((acc, item) => {
      if (item?.tableData?.checked) {
        return (
          acc +
          parseFloat(item.tempReturnedCount || 0) *
            parseFloat(item.purchasePrice)
        );
      }
      return acc;
    }, 0);
  }, [returnProducts.items]);

  const cancelBill = async () => {
    const isEditEnabled = returnProducts.items.some(
      (i) => i.editEnabled === true
    );
    if (isEditEnabled) {
      message.info(
        <>
          You need to save your changes by clicking the{" "}
          <IoIosCloseCircleOutline size={18} /> or{" "}
          <IoIosCheckmarkCircleOutline size={18} />
        </>,
        5
      );
      return;
    }

    const isFullyReturned = returnProducts.items.every(
      (i) => i.fullyReturned === true
    );
    if (isFullyReturned) {
      return message.error("All products are returned already");
    }

    if (!reasonForCancellation) {
      setCancelLoading(false);
      return message.error("Please select reason for return");
    }

    const body = {
      action: "vendorCancelBill",
      billId: data.billId,
      returnedItem: returnProducts.items
        ?.filter((i) => i?.tableData?.checked && i.tempReturnedCount)
        .map((i) => {
          return {
            productId: i.productId,
            returned: i.tempReturnedCount,
            tempReturnedCount: undefined,
          };
        }),
      returnReason: reasonForCancellation,
      returnAmount: returnedProductAmount,
    };

    if (body.returnedItem.length === 0) {
      return message.error("Please select a product to return");
    }

    setCancelLoading(true);
    console.log("cancelBillBody", body);
    try {
      const response = await fetch(
        `${config.newApiGateway}/vendor/vendorManagement`,
        {
          method: "POST",
          headers: {
            "x-api-key": `${config.newApiKey}`,
            "Content-type": "application/json",
          },
          body: JSON.stringify(body),
        }
      );
      const jsonParse = await response.json();

      console.log("cancelBillResponse", jsonParse);
      if (jsonParse.code === "Success") {
        let params = QueryString.parse(location.search);
        refetch(params.id);
        setCancelLoading(false);
        setOpen(false);
        message.success(jsonParse.message);
        setReturnProducts({});
      }
    } catch (err) {
      console.log("cancelBillError", err);
    }
  };

  return (
    <>
      <Menu.Item
        style={{
          width: "150px",
        }}
        onClick={() => {
          const returnBillData = data.items.map((i, index) => {
            const perQuantity =
              parseFloat(i.itemTotal) / parseFloat(i.count || 0);
            return {
              ...i,
              perQuantity: perQuantity,
              tableData: {
                id: index,
                checked: false,
              },
            };
          });

          setReturnProducts({
            ...data,
            items: returnBillData,
          });
          setOpen(true);
        }}
        key="return-items"
      >
        Return Items
      </Menu.Item>
      <Modal
        show={open}
        size="xl"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        {Object.keys(returnProducts).length > 0 ? (
          <div
            style={{
              minHeight: "500px",
            }}
            className="returnItemsMain"
          >
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <div></div>
              <div
                onClick={() => {
                  onClose();
                  setCancelType("");
                  // setReturnProductsItem([]);
                  // setOverallDiscount({
                  //   amount: 0,
                  //   show: true,
                  //   returned: false,
                  // });
                  // setOtherCharger([]);
                  // setBillId("");
                  // setSelectAllItems(false);
                  // setAdjustingFromDiscount("");
                }}
                className="returnItemModalClosure"
              >
                <MdOutlineClose />
              </div>
            </div>
            <div className="returnItemsHeader">
              <div style={{ color: "#EF4667", fontSize: "22PX" }}>
                Return Products
              </div>

              <div>
                {returnProducts.billReturn?.length > 0 && (
                  <Popover
                    content={
                      <div
                        style={{
                          width: 400,
                        }}
                      >
                        {returnProducts.billReturn?.map?.((i) => {
                          return (
                            <div>
                              <div>Date:{i.returnedData}</div>
                              <Row>
                                <Col span={12}>
                                  <Typography.Text strong>
                                    Item Name
                                  </Typography.Text>
                                </Col>
                                <Col span={6}>
                                  <Typography.Text strong>
                                    {" "}
                                    Quantity{" "}
                                  </Typography.Text>
                                </Col>
                                <Col span={6}>
                                  <Typography.Text strong>
                                    Amount
                                  </Typography.Text>
                                </Col>

                                {i.returnItems?.map((prod) => {
                                  const product = returnProducts.items.find(
                                    (item) => item.productId === prod.productId
                                  );

                                  return (
                                    <>
                                      <Col span={12}>{product.productName}</Col>
                                      <Col span={6}>{prod.returnedCount}</Col>
                                      <Col span={6}>
                                        {currencyFormatter(
                                          parseFloat(product.perQuantity) *
                                            parseFloat(prod.returnedCount)
                                        )}
                                      </Col>
                                    </>
                                  );
                                })}

                                <Col span={12}>Returned reason</Col>
                                <Col span={12}>{i.returnReason}</Col>

                                <Divider
                                  style={{
                                    margin: 2,
                                  }}
                                />
                              </Row>
                            </div>
                          );
                        })}
                      </div>
                    }
                    title={
                      <Typography.Title
                        level={5}
                        style={{
                          alignItems: "center",
                        }}
                      >
                        Returned History
                      </Typography.Title>
                    }
                    getPopupContainer={(trigger) => trigger.parentNode}
                  >
                    <div
                      style={{
                        display: "flex",
                        gap: "4px",
                      }}
                    >
                      <Button
                        style={{
                          fontWeight: 500,
                          color: "#5194C6",
                          fontSize: "21px",
                          paddingRight: 0,
                        }}
                        type="link"
                      >
                        History
                      </Button>
                      <DownOutlined size={14} />
                    </div>
                  </Popover>
                )}
              </div>
              {/* <div
                style={{
                  color: "#5194C6",
                  fontSize: "21px",
                  marginRight: "15px",
                }}
              >
                {returnProducts.balanceAmount > 0
                  ? `Credit Amount :  ${returnProducts.balanceAmount}`
                  : "Credit Amount :  0.00"}
              </div> */}
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  position: "relative",
                }}
              >
                <div
                  style={{
                    color: "#5194C6",
                    fontSize: "21px",
                    marginRight: "15px",
                  }}
                >
                  Invoice No : {returnProducts.invoiceNumber}
                </div>
              </div>
            </div>
            <div className="billedProductsListSection">
              {/* {returnProducts.items.map((data) => {
                return (
                  <div>
                    <div>
                      <input type="checkBox" />
                    </div>
                    <div>{data.productName}</div>
                  </div>
                );
              })} */}
              <MaterialTable
                columns={[
                  {
                    title: "Product Name",
                    field: "productName",
                    render: (data) => {
                      return (
                        <div>
                          <div>{data.productName}</div>
                          {data.fullyReturned && (
                            <div style={{ color: "red" }}>Already Returned</div>
                          )}

                          {data.productType === "combo" && (
                            <div style={{ color: "red" }}>combo</div>
                          )}

                          {(invoiceSettings.itemDiscount ||
                            invoiceSettings.itemLevelTax) && (
                            <div>
                              {(data.discount || data.taxId) && (
                                <div style={{ color: "#008080", fontSize: 12 }}>
                                  This product item has a tax/discount
                                </div>
                              )}
                            </div>
                          )}
                        </div>
                      );
                    },
                  },
                  {
                    title: `Purchase Price(${country.CurrencySymbol})`,
                    field: "purchasePrice",
                  },
                  {
                    title: "Quantity",
                    field: "count",
                    render: (data) => {
                      return <div>{data.count}</div>;
                    },
                  },
                  {
                    title: "In Stock",
                    render: (data) => {
                      const product = productList.find(
                        (product) => product.productId === data.productId
                      );

                      return (
                        <div>
                          {typeof product !== "undefined" ? (
                            <span>{product?.inventoryQty}</span>
                          ) : (
                            <span style={{ color: "red" }}>
                              Product Deleted
                            </span>
                          )}
                        </div>
                      );
                    },
                  },
                  {
                    title: "Action",
                    render: (data) => {
                      const product = productList.find(
                        (product) => product.productId === data.productId
                      );

                      return (
                        <EditableQuantity
                          data={data}
                          isProductExist={typeof product !== "undefined"}
                          setReturnProducts={setReturnProducts}
                          product={product}
                        />
                      );
                    },
                  },
                  {
                    title: "Returned Count",
                    field: "returned",
                    render: (data) => {
                      return <span>{data.returned ? data.returned : "-"}</span>;
                    },
                  },
                  // {
                  //   title: "Number of returns",
                  //   render: (data) => {
                  //     return (
                  //       <form>
                  //         <input
                  //           onChange={(e) =>
                  //             countChangeHandler(e.target.value, data)
                  //           }
                  //           value={data.returnedCount}
                  //           type="number"
                  //           disabled={
                  //             parseFloat(data.count) === 1 ||
                  //             parseFloat(data.count) -
                  //               parseFloat(
                  //                 data.returned ? data.returned : 0
                  //               ) ===
                  //               0
                  //           }
                  //           max={data.returnedCount}
                  //         />
                  //       </form>
                  //     );
                  //   },
                  // },
                ]}
                title={""}
                icons={tableIcons}
                data={returnProducts.items}
                components={{
                  Pagination: PatchedPagination,
                }}
                options={{
                  showSelectAllCheckbox:
                    !returnProducts.items?.every(
                      (i) => i.fullyReturned === true
                    ) &&
                    returnProducts.items?.every(
                      (i) => i.productType !== "combo"
                    ),
                  selection: true,
                  selectionProps: (rowData) => {
                    const product = productList.find(
                      (product) => product.productId === rowData.productId
                    );
                    const returnableQty =
                      parseFloat(rowData.count) -
                      parseFloat(rowData.returned || 0);
                    return {
                      disabled:
                        typeof product === "undefined" ||
                        product.inventoryQty < returnableQty ||
                        rowData.productType === "combo" ||
                        parseFloat(rowData.count) ===
                          parseFloat(rowData.returned),
                    };
                  },
                }}
                onSelectionChange={(rows, rowData) => {
                  if (rowData) {
                    if (rowData?.tableData?.checked) {
                      // if selected specific row
                      const updatedReturnProductList = returnProducts.items.map(
                        (product) => {
                          if (product.productId === rowData.productId) {
                            return {
                              ...product,
                              tempReturnedCount:
                                parseFloat(product.count) -
                                parseFloat(product.returned || 0),
                              tableData: {
                                ...rowData.tableData,
                                checked: true,
                              },
                            };
                          }
                          return product;
                        }
                      );
                      setReturnProducts((prev) => ({
                        ...prev,
                        items: updatedReturnProductList,
                      }));
                    } else if (!rowData?.tableData?.checked) {
                      // if unselected specific row
                      const updatedReturnProductList = returnProducts.items.map(
                        (product) => {
                          if (product.productId === rowData?.productId) {
                            return {
                              ...product,
                              tempReturnedCount: 0,
                              tableData: {
                                ...rowData.tableData,
                                checked: false,
                              },
                            };
                          }
                          return product;
                        }
                      );
                      setReturnProducts((prev) => ({
                        ...prev,
                        items: updatedReturnProductList,
                      }));
                    }
                  } else if (rows.length === returnProducts.items?.length) {
                    // if selected all rows

                    const updatedReturnProductList = returnProducts.items.map(
                      (product) => {
                        const rowData = rows.find(
                          (i) => i.productId === product.productId
                        );

                        const currentProductData = productList.find(
                          (i) => i.productId === product.productId
                        );
                        console.log(
                          "currentProductData99",
                          currentProductData?.inventoryQty >=
                            parseFloat(rowData.count) -
                              parseFloat(rowData.returned || 0)
                            ? true
                            : typeof currentProductData !== "undefined"
                            ? true
                            : false,
                          currentProductData?.inventoryQty >=
                            parseFloat(rowData.count) -
                              parseFloat(rowData.returned || 0),
                          typeof currentProductData !== "undefined",
                          parseFloat(rowData.count) -
                            parseFloat(rowData.returned || 0),
                          currentProductData?.inventoryQty,

                          currentProductData
                        );
                        if (product.productId === rowData.productId) {
                          return {
                            ...product,
                            tempReturnedCount:
                              parseFloat(product.count) -
                              parseFloat(product.returned || 0),
                            tableData: {
                              ...rowData.tableData,
                              checked:
                                currentProductData?.inventoryQty >=
                                parseFloat(rowData.count) -
                                  parseFloat(rowData.returned || 0)
                                  ? true
                                  : false,
                            },
                          };
                        }
                        return product;
                      }
                    );

                    setReturnProducts((prev) => ({
                      ...prev,
                      items: updatedReturnProductList,
                    }));
                  } else if (rows.length === 0) {
                    // if unselected all rows
                    const updatedReturnProductList = returnProducts.items.map(
                      (product) => {
                        return {
                          ...product,
                          tableData: {
                            ...product.tableData,
                            checked: false,
                          },
                          tempReturnedCount: 0,
                        };
                      }
                    );
                    setReturnProducts((prev) => ({
                      ...prev,
                      items: updatedReturnProductList,
                    }));
                  }
                }}
              />
            </div>
            <div className="returnModalFooter">
              <div>
                <div className="returnReasonSelect">
                  <Form.Control
                    as="select"
                    value={reasonForCancellation}
                    onChange={(e) => setReasonForCancellation(e.target.value)}
                    // disabled={billFullyReturned}
                  >
                    <option value="" disabled>
                      Choose Return Reason
                    </option>
                    <option value="Duplicate invoice number">
                      Duplicate invoice number
                    </option>
                    <option value="Order Cancellation">
                      Order Cancellation
                    </option>
                    <option value="Product returns">Product returns</option>
                    <option value="Others">Others</option>
                  </Form.Control>
                </div>
              </div>
              {console.log("balanceAmount", data.balanceAmount)}
              <div
                style={{
                  maxWidth: "300px",
                }}
              >
                <div className="repayAmountContainer">
                  <div>
                    <div>Total Return Amount:</div>
                  </div>
                  <div>
                    <div
                      style={{
                        color: "red",
                        fontWeight: "600",
                      }}
                    >
                      {parseFloat(returnedProductAmount || 0).toFixed("2")}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <Modal.Footer>
              {!billFullyReturned && (
                <button
                  className="addAddrButton"
                  style={{
                    border: "0",
                    backgroundColor: "#ef4667",
                    color: "#fff",
                    fontSize: "15px",
                    fontWeight: "600",
                    borderRadius: "6px",
                    padding: "10px 14px",
                  }}
                  onClick={() => {
                    cancelBill();
                  }}
                  disabled={cancelLoading}
                >
                  Confirm
                  {cancelLoading && (
                    <Spinner
                      variant="primary"
                      animation="border"
                      size="sm"
                      style={{
                        marginLeft: "10px",
                        backgroundColor: "#fff",
                      }}
                    />
                  )}
                </button>
              )}
            </Modal.Footer>
          </div>
        ) : (
          <div>loading...</div>
        )}
      </Modal>
    </>
  );
};

export default ReturnBillModal;

function PatchedPagination(props) {
  const {
    ActionsComponent,
    onChangePage,
    onChangeRowsPerPage,
    ...tablePaginationProps
  } = props;

  return (
    <TablePagination
      {...tablePaginationProps}
      // @ts-expect-error onChangePage was renamed to onPageChange
      onPageChange={onChangePage}
      onRowsPerPageChange={onChangeRowsPerPage}
      ActionsComponent={(subprops) => {
        const { onPageChange, ...actionsComponentProps } = subprops;
        return (
          // @ts-expect-error ActionsComponent is provided by material-table
          <ActionsComponent
            {...actionsComponentProps}
            onChangePage={onPageChange}
          />
        );
      }}
    />
  );
}

const EditableQuantity = ({
  data,
  setReturnProducts,
  isProductExist,
  product,
}) => {
  const [editable, setEditable] = useState({
    show: false,
    count: 0,
  });

  useEffect(() => {
    setReturnProducts((prev) => {
      return {
        ...prev,
        items: prev.items.map((i) => {
          if (i.productId === data.productId) {
            return {
              ...i,
              editEnabled: editable.show,
            };
          }
          return i;
        }),
      };
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [editable.show, data.productId]);

  return (
    <div key={data.productId}>
      {!editable.show && (
        <div>
          {(data.tempReturnedCount
            ? parseFloat(data.tempReturnedCount)
            : parseFloat(data.count) - parseFloat(data.returned || 0)
          ).toFixed(2)}

          <>
            {data.productType !== "combo" && (
              <>
                {data.fullyReturned ? (
                  <Tooltip title="Already Returned">
                    <EditJsx
                      availableReturn={
                        parseFloat(data.count) - parseFloat(data.returned || 0)
                      }
                      isProductExist={isProductExist}
                      setEditable={setEditable}
                      fullyReturned={data.fullyReturned}
                      tempReturnedCount={data.tempReturnedCount}
                    />
                  </Tooltip>
                ) : (
                  <EditJsx
                    setEditable={setEditable}
                    fullyReturned={data.fullyReturned}
                    availableReturn={
                      parseFloat(data.count) - parseFloat(data.returned || 0)
                    }
                    isProductExist={isProductExist}
                    tempReturnedCount={data.tempReturnedCount}
                  />
                )}
              </>
            )}
          </>
        </div>
      )}

      {editable.show && (
        <div
          style={{
            display: "flex",
            alignItems: "center",
          }}
        >
          <span
            style={{
              display: "inline-flex",
              border: "1px solid #ccc",
            }}
          >
            <Button
              style={{
                backgroundColor: "transparent",
                border: "0",
                padding: 0,
                height: 20,
              }}
              disabled={editable.count <= 1}
              onClick={() => {
                setEditable((prev) => ({
                  ...prev,
                  count: prev.count - 1,
                }));
              }}
            >
              <BiMinus
                size={20}
                style={{
                  cursor: "pointer",
                }}
              />
            </Button>

            <span
              style={{
                borderRight: "1px solid #ccc",
                borderLeft: "1px solid #ccc",
                padding: "0 6px",
                userSelect: "none",
              }}
            >
              {parseFloat(editable.count).toFixed(2)}
            </span>
            <Button
              style={{
                backgroundColor: "transparent",
                border: "0",
                padding: 0,
                height: 20,
              }}
              disabled={
                editable.count ===
                parseFloat(data.count || 0) - parseFloat(data.returned || 0)
              }
              onClick={() => {
                setEditable((prev) => ({
                  ...prev,
                  count: prev.count + 1,
                }));
              }}
            >
              <BiPlus size={20} />
            </Button>
          </span>
          <span>
            <button
              style={{
                backgroundColor: "transparent",
                border: "0",
                padding: 0,
              }}
              onClick={() => {
                setEditable({
                  show: false,
                  count: 0,
                });
              }}
            >
              <IoIosCloseCircleOutline
                role="button"
                style={{
                  cursor: "pointer",
                }}
                size={20}
              />
            </button>
            <button
              style={{
                backgroundColor: "transparent",
                border: "0",
                padding: 0,
              }}
              onClick={() => {
                if (product.inventoryQty < editable.count) {
                  message.error("Insufficient Stock");
                  return;
                }
                const productTemp = {
                  ...data,
                };
                setReturnProducts((prev) => {
                  return {
                    ...prev,
                    items: prev.items.map((i) => {
                      if (i.productId === data.productId) {
                        return {
                          ...productTemp,
                          tempReturnedCount: editable.count,
                          tableData: {
                            ...i.tableData,
                            checked: true,
                          },
                        };
                      }
                      return i;
                    }),
                  };
                });
                setEditable({
                  show: false,
                  count: 0,
                });
              }}
            >
              <IoIosCheckmarkCircleOutline
                style={{
                  cursor: "pointer",
                }}
                size={20}
              />
            </button>
          </span>
        </div>
      )}
    </div>
  );
};

const EditJsx = ({
  setEditable = () => {},
  availableReturn,
  fullyReturned,
  isProductExist = false,
}) => {
  return (
    <button
      style={{
        backgroundColor: "transparent",
        border: "0",
        padding: 0,
        height: 20,
      }}
      onClick={() => {
        setEditable({
          show: true,
          count: parseFloat(availableReturn),
        });
      }}
      disabled={isProductExist === false || fullyReturned}
    >
      <AiFillEdit />
    </button>
  );
};
